<!--
Author:
Create Time: 2020-04-13 09:22:08
Description: 人口信息选择框
-->
<template>
  <div class="com-proPerson-select">
      <span>
          <el-input
            placeholder
            v-model="label"
            @focus="handleInputClick"
            :disabled="disabled"
            data-ignore-clearable="true"
            data-ignore-at-clear="handleClear"
            :title="label"
            clearable
          >
            <i
            class="el-icon-search el-input__icon"
            slot="suffix">
            </i>
            </el-input>
      </span>

      <proPersonRef
        ref="proPersonRef"
        :visible="isPropersonRefVisible"
        :custByorgId="custByorgId"
        :houseId="houseId"
        @confirm="handlePropersonRefConfirm"
        :multiple="multiple"
        @cancel="handlePropersonRefCancel"
        append-to-body
        width="65%"
        :politicsStatus="politicsStatus"
      />
  </div>
</template>

<script>
export default {
  name: 'proPersonSelect',
  props: {
      value: {
          type: [String, Array, undefined],
          default: () => ''
      },
      label: {
          type: String,
          default: () => ''
      },
      disabled: {
          type: Boolean,
          default: () => false
      },
      politicsStatus : {
          type: Boolean,
          default: () => false
      },
      custByorgId: {//客户档案新增属性：true-排除数据空校验
      type: Boolean,  
      default: () => false
    },
    houseId: {
      type: String,
      default: () => ""
    },
  },
  data () {
    return {
        isPropersonRefVisible: false,
    }
  },
  computed: {
      multiple() {
          return Array.isArray(this.value);
      },
  },
  methods: {
      handleInputClick() {
          this.isPropersonRefVisible = true;
      },
      handleClear() {},
      handlePropersonRefConfirm(value) {
          let val = Array.isArray(value) ? value.map(o => o.id) : value.id;
          this.$emit('update:value', val, value);
          this.$emit('change', val, value);
          this.$emit('input', val, value);
          this.isPropersonRefVisible = false;
      },
      handlePropersonRefCancel() {
          this.isPropersonRefVisible = false;
      },
  }
}
</script>

<style scoped lang="less">
.com-proPerson-select {
    display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/proPerson/proPersonSelect.vue